import { useClientEnvVarsStore } from '@marriott/mi-store-utils';

export const useIsFeatureFlagActive = (featureFlag: string) => {
  const featureFlags = useClientEnvVarsStore(state => state.envVarsObject['featureFlags']) as unknown as Record<
    string,
    unknown
  >;

  const isActive = featureFlags && featureFlags[featureFlag];

  return isActive === true;
};
